import React from "react";
import PropTypes from "prop-types";
import { Colors } from "../../constants/Colors";
import styled from "styled-components";
import PENDO_LINK_ID from "../../constants/pendoConstants";
const CustomEmailLink= styled.a`
  &:focus {
   outline:  2px solid  ${Colors.activeDefault};
   }
  word-wrap: break-word;
`

const EmailLink = ({ email, color = Colors.black, fontWeight = 700 }) => {
  return (
    <CustomEmailLink id = {PENDO_LINK_ID.REDBALL_EMAIL_LINK} href={`mailto:${email}`} style={{ color, fontWeight, textDecoration: "underline" }}>
      {email}
    </CustomEmailLink>
  );
};

EmailLink.propTypes = {
  email: PropTypes.string.isRequired,
  color: PropTypes.string,
  fontWeight: PropTypes.number
};

export default EmailLink;